'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createConnector = require('../core/createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getId() {
  return 'page';
}

function getCurrentRefinement(props, searchState) {
  var id = getId();
  var page = searchState[id];
  if (typeof page === 'undefined') {
    page = 1;
  } else if (typeof page === 'string') {
    page = parseInt(page, 10);
  }
  if (props.defaultRefinement) {
    return props.defaultRefinement;
  }
  return page;
}

/**
 * connectPagination connector provides the logic to build a widget that will
 * let the user displays hits corresponding to a certain page.
 * @name connectPagination
 * @kind connector
 * @propType {string} id - widget id, URL searchState serialization key. The searchState of this widget takes the shape of a `number`.
 * @propType {boolean} [showFirst=true] - Display the first page link.
 * @propType {boolean} [showLast=false] - Display the last page link.
 * @propType {boolean} [showPrevious=true] - Display the previous page link.
 * @propType {boolean} [showNext=true] - Display the next page link.
 * @propType {number} [pagesPadding=3] - How many page links to display around the current page.
 * @propType {number} [maxPages=Infinity] - Maximum number of pages to display.
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {number} nbPages - the total of existing pages
 * @providedPropType {number} currentRefinement - the page refinement currently applied
 */

var _default = (0, _createConnector2.default)({
  displayName: 'AlgoliaPagination',

  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    if (!searchResults.results) {
      return null;
    }
    return {
      nbPages: searchResults.results.nbPages,
      currentRefinement: getCurrentRefinement(props, searchState)
    };
  },
  refine: function refine(props, searchState, nextPage) {
    var id = getId();
    return _extends({}, searchState, _defineProperty({}, id, nextPage));
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0, _omit3.default)(searchState, getId());
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setPage(getCurrentRefinement(props, searchState) - 1);
  },
  transitionState: function transitionState(props, prevSearchState, nextSearchState) {
    var id = getId();
    if (nextSearchState[id] && nextSearchState[id].isSamePage) {
      return _extends({}, nextSearchState, _defineProperty({}, id, prevSearchState[id]));
    } else if (prevSearchState[id] === nextSearchState[id]) {
      return (0, _omit3.default)(nextSearchState, id);
    }
    return nextSearchState;
  },
  getMetadata: function getMetadata() {
    return { id: getId() };
  }
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getId, 'getId', 'src/connectors/connectPagination.js');

  __REACT_HOT_LOADER__.register(getCurrentRefinement, 'getCurrentRefinement', 'src/connectors/connectPagination.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/connectors/connectPagination.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/connectors/connectPagination.js
// module id = 520
// module chunks = 0